import interceptedAxios from '../../../utils/interceptedAxios'
import { z } from 'zod'

const ZHsmRegularKEK = z.object({
  id: z.string(),
  label: z.string(),
  tenant: z.string(),
  use: z.number(),
  createdBy: z.string(),
  createdAt: z.string()
})

export const ZHsmRegularKEKListDTO = z.object({
  total_count: z.number(),
  list: z.array(ZHsmRegularKEK)
})

const ZCryptoRequest = z.object({
  requestId: z.string(),
  requestType: z.string(),
  requestStatus: z.string(),
  result: ZHsmRegularKEKListDTO.nullable(),
  errorMessage: z.string().nullable()
})

export const ZApiSuccessResponse = z.object({
  http_status: z.number(),
  error: z.boolean(),
  data: ZCryptoRequest
})

export type HsmRegularKEK = z.infer<typeof ZHsmRegularKEK>
export type HsmRegularKEKListDTO = z.infer<typeof ZHsmRegularKEKListDTO>
export type CryptoRequest = z.infer<typeof ZCryptoRequest>
export type ApiSuccessResponse = z.infer<typeof ZApiSuccessResponse>

export async function getHsmKeksRequestStatus (
  requestId: string,
  onSuccess: (cryptoRequest: CryptoRequest, kekList?: HsmRegularKEKListDTO) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = `/app-config-service/api/v1/crypto/status/${requestId}`
  interceptedAxios
    .get(url)
    .then((response) => {
      const parseResponse = ZApiSuccessResponse.safeParse(response.data)
      if (parseResponse.success) {
        const cryptoRequest = parseResponse.data.data
        let kekList: HsmRegularKEKListDTO | undefined
        if (cryptoRequest.requestStatus === 'DONE' && cryptoRequest.result !== undefined && cryptoRequest.result !== null) {
          kekList = cryptoRequest.result
        }
        onSuccess(cryptoRequest, kekList)
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}

export default getHsmKeksRequestStatus
